import { Controller } from "@hotwired/stimulus"

// Switches the single-page exam between the answer sheet and the options under each
// question without leaving the page. The view lives in one attribute that the
// stylesheet's sheet-view and inline-view variants read; the question being read keeps
// its place on screen while the layout around it changes, and the choice is saved in the
// background so a reload opens the same way.
export default class extends Controller {
  static targets = ["option", "finish", "progress"]
  static values = { completeConfirmation: String, incompleteConfirmation: String }

  connect() {
    this.updateConfirmation()
  }

  progressTargetConnected() {
    this.updateConfirmation()
  }

  updateConfirmation() {
    const complete = this.progressTarget.dataset.complete === "true"
    this.finishTargets.forEach((form) => {
      form.dataset.turboConfirm = complete ? this.completeConfirmationValue : this.incompleteConfirmationValue
    })
  }

  switch(event) {
    event.preventDefault()
    const button = event.submitter
    const view = button.value === "1" ? "sheet" : "inline"
    if (view === this.element.dataset.examView) return

    const apply = () => this.apply(view)
    if (document.startViewTransition && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
      document.startViewTransition(apply)
    } else {
      apply()
    }
    this.save(event.target, button)
  }

  apply(view) {
    const reading = this.reading()
    const before = reading?.getBoundingClientRect().top
    this.element.dataset.examView = view
    this.optionTargets.forEach((option) => option.setAttribute("aria-pressed", option.value === (view === "sheet" ? "1" : "0")))
    if (reading) window.scrollBy(0, reading.getBoundingClientRect().top - before)
    this.dispatch("change", { detail: { view } })
  }

  // The first question whose bottom is still below the sticky exam bar.
  reading() {
    const bar = this.element.querySelector("[data-exam-bar]")
    const top = bar ? bar.getBoundingClientRect().bottom : 0
    return [...this.element.querySelectorAll("article[data-position]")]
      .find((article) => article.getBoundingClientRect().bottom > top + 1)
  }

  save(form, button) {
    const body = new FormData(form)
    body.set(button.name, button.value)
    // Only the preference rides on this, so a failed save just means the next reload
    // opens in the old view.
    fetch(form.action, { method: "POST", body, headers: { Accept: "application/json" } }).catch(() => {})
  }
}
